import React from 'react';
import { Button } from '@mui/material';

const ContainedButton = ({ children, sx = {}, ...props }) => {
  return (
    <Button
      variant="contained"
      size="small"
      sx={{
        backgroundColor: "var(--id-color)",
        color: "#fff",
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default ContainedButton;
